/* Momentoss Produktseite: Farbwahl, Lieferdatum, Bewertungen, Passt dazu, Kaufleiste (Stand 27.10.2026) */
(function () {
  'use strict';
  var root = document.getElementById('mo-pdp');
  if (!root || root.getAttribute('data-mo-init')) return;
  root.setAttribute('data-mo-init', '1');

  var RX = /^(.*?)\bSilber (rhodiniert|rosé vergoldet|vergoldet|)\s*(.*?)\s*,\s*Textil\s+(.+)$/;
  var MCODE = { 'rhodiniert': 's', 'vergoldet': 'g' };
  MCODE['rosé vergoldet'] = 'r';
  var MNAME = { r: 'Rosé vergoldet', s: 'Silber rhodiniert', g: 'Vergoldet' };
  var MSHORT = { r: 'Rosé', s: 'Silber', g: 'Gold' };
  var MDOT = {
    r: 'linear-gradient(135deg,#e7b9a3,#c98f7a)',
    s: 'linear-gradient(135deg,#f1f1f1,#a9a9a9)',
    g: 'linear-gradient(135deg,#f3dc8c,#c9a23a)'
  };
  var MORDER = ['r', 's', 'g'];
  var HEX = {
    'rot': ['#c62828'], 'schwarz': ['#1a1a1a'], 'beige': ['#d8c3a5'], 'babyrosa': ['#f4c7d2'],
    'dunkelrot': ['#8b1e2d'], 'gelb': ['#f2c230'], 'braun-beige': ['#7a5240', '#d8c3a5'], 'braun': ['#6b4430'],
    'grau-lila': ['#8e8299'], 'dunkelgrau': ['#555555'], 'hellgrau': ['#c9c9c9'], 'türkis': ['#2bb3b1'],
    'hellblau': ['#9cc9e6'], 'blau': ['#2f6fd0'], 'royalblau': ['#2340a8'], 'dunkelblau': ['#1f2f5c'],
    'petrolblau': ['#1f6f7a'], 'grün': ['#2e7d32'], 'neon-grün': ['#8ce63c'], 'hellrosa': ['#f8d3dc'],
    'rosa-braun': ['#d89ba8', '#7a5240'], 'dunkelrosa': ['#c2507a'], 'pink': ['#e8559a'], 'orange': ['#f08a24'],
    'rosa': ['#f2a7bb'], 'grau': ['#9a9a9a'], 'lila': ['#8e6bb0']
  };
  var PALETTE = ['rosa-braun', 'rot', 'dunkelrot', 'dunkelrosa', 'pink', 'hellrosa', 'babyrosa', 'orange', 'gelb',
    'beige', 'braun-beige', 'braun', 'grau-lila', 'hellgrau', 'dunkelgrau', 'schwarz', 'türkis', 'hellblau',
    'blau', 'royalblau', 'dunkelblau', 'petrolblau', 'grün', 'neon-grün'];
  /* Farben nach Shop-Verkäufen der letzten 12 Monate (Stand 26.10.2026) */
  var POP = ['rosa-braun', 'schwarz', 'braun-beige', 'dunkelrosa', 'hellrosa', 'dunkelgrau', 'dunkelblau',
    'grau-lila', 'hellgrau', 'dunkelrot', 'türkis', 'rot'];
  /* Passt dazu: nur Motive ohne Gravur (Unico hat Gravur -> nicht per Schnellkauf) */
  /* Farben, die auslaufen: nicht als Farbkreis / Vorschlag zeigen */
  var HIDE = ['hellrosa'];
  /* Passt dazu: Partner-Kollektionen nach Verkäufen (12 Monate). Nie dieselbe Motivgruppe wie das eigene Armband
     und nie zwei aus derselben Gruppe (Alexander 29.10.: „wozu zwei Herzen tragen?“) */
  var PARTNER = ['engelarmband', 'blume-zirkonia', 'herz-zirkonia', 'herz-pave-zirkonia', 'cloverleaf',
    'infinity-armband', 'schutzengelarmband', 'katzenarmband', 'ankerarmband', 'elefantenarmband'];
  function grp(key) {
    var G = [[/engel/, 'engel'], [/herz/, 'herz'], [/blume|flower|lotus/, 'blume'], [/clover|klee/, 'klee'],
      [/infinity/, 'infinity'], [/katze|elefant|pfote|hund|eule/, 'tier'], [/anker/, 'anker'], [/kreuz/, 'kreuz'], [/stern/, 'stern']];
    for (var i = 0; i < G.length; i++) if (G[i][0].test(key)) return G[i][1];
    return key;
  }
  /* Passt dazu: Partnerfarben je Bandfarbe (1-2-3). Basis: gemeinsame Käufe in Bestellungen 01/2024-10/2026
     (Top-Farben), bei seltenen Farben Farbregeln (Ton in Ton, Neutral + Akzent). Freigegeben 28.10.2026 */
  var PAIR = {
    'rosa-braun': ['braun-beige', 'dunkelrosa', 'grau-lila'],
    'schwarz': ['braun-beige', 'dunkelgrau', 'dunkelrot'],
    'braun-beige': ['rosa-braun', 'dunkelgrau', 'hellgrau'],
    'dunkelrot': ['schwarz', 'dunkelblau', 'braun-beige'],
    'hellgrau': ['dunkelgrau', 'braun-beige', 'rosa-braun'],
    'dunkelgrau': ['hellgrau', 'braun-beige', 'rosa-braun'],
    'dunkelrosa': ['rosa-braun', 'schwarz', 'dunkelblau'],
    'rot': ['rosa-braun', 'schwarz', 'beige'],
    'dunkelblau': ['dunkelrot', 'dunkelrosa', 'grau-lila'],
    'grau-lila': ['rosa-braun', 'dunkelblau', 'braun-beige'],
    'türkis': ['dunkelrosa', 'hellblau', 'grün'],
    'petrolblau': ['schwarz', 'rosa-braun', 'türkis'],
    'braun': ['schwarz', 'rosa-braun', 'beige'],
    'hellblau': ['türkis', 'dunkelrosa', 'dunkelblau'],
    'pink': ['dunkelrosa', 'babyrosa', 'schwarz'],
    'blau': ['hellblau', 'dunkelblau', 'hellgrau'],
    'babyrosa': ['dunkelrosa', 'rosa-braun', 'hellgrau'],
    'royalblau': ['babyrosa', 'hellblau', 'hellgrau'],
    'beige': ['braun', 'rosa-braun', 'dunkelblau'],
    'grün': ['türkis', 'braun-beige', 'beige'],
    'orange': ['dunkelblau', 'braun-beige', 'braun'],
    'gelb': ['dunkelgrau', 'hellblau', 'beige'],
    'neon-grün': ['schwarz', 'dunkelgrau', 'türkis'],
    'hellrosa': ['rosa-braun', 'braun-beige', 'hellgrau']
  };
  /* Feiertage AT (keine Zustellung) */
  var HOLI = ['2026-10-26', '2026-11-01', '2026-12-08', '2026-12-25', '2026-12-26', '2027-01-01', '2027-01-06',
    '2027-03-29', '2027-05-01', '2027-05-06', '2027-05-17', '2027-05-27', '2027-08-15', '2027-10-26',
    '2027-11-01', '2027-12-08', '2027-12-25', '2027-12-26'];

  function slug(s) {
    s = s.toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss').replace(/[éè]/g, 'e');
    return s.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function normColor(c) {
    return c.trim().toLowerCase().replace(/\s*\/\s*/g, '/').replace(/\s+/g, '-');
  }
  function parse(title, handle) {
    var m = RX.exec(title || '');
    if (!m || !(m[2] in MCODE)) return null;
    var pre = m[1].trim();
    var motif = m[3].replace(/^[\s,]+|[\s,]+$/g, '');
    var key = slug(pre + ' ' + motif);
    if (/zirkonia/.test(handle) && key.indexOf('zirkonia') < 0) key += '-zirkonia';
    var name = pre === 'Armband' && motif ? motif : (pre === 'Armband Unico' ? 'Unico' : (pre + ' ' + motif).trim());
    return { key: key, m: MCODE[m[2]], c: normColor(m[4]), name: name, num: /^\d+$/.test(handle) };
  }
  function cap(c) {
    return c.split('/').map(function (p) {
      return p.split('-').map(function (b) { return b.charAt(0).toUpperCase() + b.slice(1); }).join('-');
    }).join('/');
  }
  function swatchBg(c, img) {
    var parts = c.split('/'), cols = [];
    parts.forEach(function (p) { var h = HEX[p]; if (h) cols = cols.concat(parts.length > 1 ? [h[0]] : h); });
    if (!cols.length) return img ? 'center/cover no-repeat url("' + img + '")' : '#ddd';
    if (cols.length === 1) return cols[0];
    return 'linear-gradient(135deg,' + cols[0] + ' 50%,' + cols[1] + ' 50%)';
  }
  function money(cents) {
    var e = cents / 100;
    return (e % 1 === 0 ? e.toFixed(0) : e.toFixed(2).replace('.', ',')) + ' €';
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function el(sel) { return document.querySelector(sel); }
  function colOrder(c) { var i = PALETTE.indexOf(c); return i < 0 ? 100 + c.length : i; }
  function popOrder(c) { var i = POP.indexOf(c); return i < 0 ? 50 + colOrder(c) : i; }

  var me = parse(root.getAttribute('data-title'), root.getAttribute('data-handle'));
  var wahl = root.querySelector('[data-mo-wahl]');

  /* ---------- Lieferdatum ---------- */
  (function delivery() {
    var box = root.querySelector('[data-mo-ship]');
    if (!box) return;
    function iso(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
    function addBD(d, n) {
      var x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
      while (n > 0) {
        x.setDate(x.getDate() + 1);
        var wd = x.getDay();
        if (wd !== 0 && wd !== 6 && HOLI.indexOf(iso(x)) < 0) n--;
      }
      return x;
    }
    function fmt(d) {
      var wd = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'][d.getDay()];
      return wd + ', ' + d.getDate() + '.' + (d.getMonth() + 1) + '.';
    }
    /* Lieferzeiten stehen fest im Versand-Kasten (Liquid). Hier nur Weihnachtshinweis 1.–17.12. */
    var now = new Date(), md = iso(now).slice(5);
    if (md >= '12-01' && md <= '12-17') {
      var x = document.createElement('div');
      x.className = 'mo-sc-xmas';
      x.textContent = 'Rechtzeitig zu Weihnachten: Österreich bis 17.12.' + (md <= '12-14' ? ', Deutschland bis 14.12.' : '') + ' bestellen';
      box.appendChild(x);
    }
  })();

  /* ---------- Kaufleiste am Handy ---------- */
  (function sticky() {
    var atc = document.getElementById('addToCart');
    if (!atc || !('IntersectionObserver' in window)) return;
    var form = atc.closest('form');
    var gravur = form && form.querySelector('.product-personalizer');
    var bar = document.createElement('div');
    bar.className = 'mo-sticky';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<img alt="" src="' + esc(root.getAttribute('data-img') || '') + '" width="44" height="44">' +
      '<div class="mo-st-t"><b>' + esc(root.getAttribute('data-short') || '') + '</b><span>' + esc(root.getAttribute('data-pfmt') || '') + '</span></div>' +
      '<button type="button" tabindex="-1">' + (gravur ? 'Gravur wählen' : 'In den Warenkorb') + '</button>';
    document.body.appendChild(bar);
    /* Button der Leiste in derselben Farbe wie der Warenkorb-Button */
    var cs = getComputedStyle(atc), bb = bar.querySelector('button');
    bb.style.background = cs.backgroundColor; bb.style.color = cs.color;
    if (cs.borderTopWidth !== '0px') bb.style.border = cs.borderTopWidth + ' solid ' + cs.borderTopColor;
    bar.querySelector('button').addEventListener('click', function () {
      if (gravur || atc.disabled) { (gravur || atc).scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      atc.click();
      bar.classList.remove('is-on');
    });
    new IntersectionObserver(function (en) {
      var e = en[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', past);
    }).observe(atc);
  })();

  /* ---------- Desktop: Reiter + Passt dazu nebeneinander, darunter Bewertungen über die ganze Breite ---------- */
  (function desktopRows() {
    var cont = document.querySelector('.product__section-container');
    function grab(sel) { var b = document.querySelector(sel); return b ? { b: b, home: b.parentNode, next: b.nextSibling } : null; }
    var desc = grab('.product__section-content__block--product_description');
    var duo = grab('.product__section-content__block--mo-duo');
    var rev = grab('.product__section-content__block--mo-bewertungen');
    if (!cont || !window.matchMedia) return;
    var band = document.createElement('div');
    band.className = 'mo-full';
    band.innerHTML = '<div class="mo-row"><div class="mo-row-l"></div><div class="mo-row-r"></div></div><div class="mo-row-b"></div>';
    cont.parentNode.insertBefore(band, cont.nextSibling);
    var slots = [[desc, band.querySelector('.mo-row-l')], [duo, band.querySelector('.mo-row-r')], [rev, band.querySelector('.mo-row-b')]];
    var mq = window.matchMedia('(min-width: 750px)');
    function place() {
      slots.forEach(function (x) {
        if (!x[0]) return;
        if (mq.matches) { if (x[0].b.parentNode !== x[1]) x[1].appendChild(x[0].b); }
        else if (x[0].b.parentNode !== x[0].home) x[0].home.insertBefore(x[0].b, x[0].next);
      });
    }
    place();
    if (mq.addEventListener) mq.addEventListener('change', place); else if (mq.addListener) mq.addListener(place);
  })();

  if (!me) { if (wahl) wahl.remove(); return; }

  /* ---------- Familie laden ---------- */
  var cols = (root.getAttribute('data-cols') || '').split(',').filter(Boolean).map(function (s) {
    var i = s.indexOf(':'); return { n: +s.slice(0, i), h: s.slice(i + 1) };
  }).sort(function (a, b) { return a.n - b.n; }).slice(0, 3);

  var cache = {};
  /* JSON holen, bei Fehler einmal nach kurzer Pause wiederholen (langsames Handynetz) */
  /* Bild-URL des kleinen Farbbilds: gleiche Datei, 240 px (muss zur Snippet-URL passen -> Browser-Cache) */
  function thumbU(u) { return String(u || '').replace(/([?&])width=\d+/, '$1width=240'); }
  function getJSON(url) {
    function once() {
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (t) { return JSON.parse(t); });
    }
    return once().catch(function () { return new Promise(function (ok) { setTimeout(ok, 1200); }).then(once); });
  }
  function loadCol(h) {
    if (!cache[h]) {
      var key = 'moCol:' + h, hit = null;
      try { hit = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (x) {}
      if (hit && Date.now() - hit.t < 600000 && hit.d && hit.d.items) {
        cache[h] = Promise.resolve(hit.d);
      } else {
        cache[h] = getJSON('/collections/' + encodeURIComponent(h) + '?view=mofam')
          .then(function (d) { try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: d })); } catch (x) {} return d; })
          .catch(function () { return { items: [] }; });
      }
    }
    return cache[h];
  }
  function members(data, key) {
    var out = [];
    (data.items || []).forEach(function (p) {
      var f = parse(p.t, p.h);
      if (f && f.key === key && (HIDE.indexOf(f.c) < 0 || p.h === root.getAttribute('data-handle'))) { f.p = p; out.push(f); }
    });
    return out;
  }
  function dedupe(list) {
    var map = {};
    list.forEach(function (f) {
      var k = f.m + '|' + f.c, cur = map[k];
      if (f.p.h === root.getAttribute('data-handle')) { map[k] = f; return; }
      if (cur && cur.p.h === root.getAttribute('data-handle')) return;
      function score(x) {
        return (x.num === me.num ? 0 : 4) + (/kopie/.test(x.p.h) ? 2 : 0) + (x.p.a ? 0 : 1);
      }
      if (!cur || score(f) < score(cur)) map[k] = f;
    });
    return map;
  }

  Promise.all(cols.map(function (c) { return loadCol(c.h).then(function (d) { return { c: c, d: d }; }); }))
    .then(function (res) {
      var best = null, bestN = 0;
      res.forEach(function (r) {
        var n = members(r.d, me.key).length;
        if (n > bestN) { best = r; bestN = n; }
      });
      if (!best || bestN < 2) { if (wahl) wahl.remove(); return; }
      var fam = members(best.d, me.key);
      var map = dedupe(fam);
      buildWahl(map);
      lazy('[data-mo-rev]', function (sec) { buildReviews(sec, best.c.h, fam); });
      lazy('[data-mo-duo]', function (sec) { buildDuo(sec, best.c.h, map); });
    });

  /* ---------- Metall + Farben ---------- */
  function buildWahl(map) {
    var metals = MORDER.filter(function (m) {
      return Object.keys(map).some(function (k) { return k.indexOf(m + '|') === 0; });
    });
    var mBox = root.querySelector('[data-mo-metals]');
    if (metals.length > 1) {
      mBox.innerHTML = metals.map(function (m) {
        var items = Object.keys(map).filter(function (k) { return k.indexOf(m + '|') === 0; }).map(function (k) { return map[k]; });
        var minP = Math.min.apply(null, items.map(function (f) { return f.p.p; }));
        var target = map[m + '|' + me.c] || items.sort(function (a, b) { return colOrder(a.c) - colOrder(b.c); })[0];
        return '<a class="mo-metal" href="/products/' + target.p.h + '" data-i="' + thumbU(target.p.i) + '"' + (m === me.m ? ' aria-current="true"' : '') +
          '><i style="background:' + MDOT[m] + '"></i><span class="mo-mt"><span class="mo-mn"><span class="mo-mfull">' + MNAME[m] + '</span><span class="mo-mshort">' + MSHORT[m] + '</span></span><small>' + money(minP) + '</small></span></a>';
      }).join('');
      /* 3 Metalle (Rosé/Silber/Gold): am Handy Kurznamen, sonst wird „Silber rhodiniert“ abgeschnitten */
      mBox.classList.toggle('mo-m3', metals.length >= 3);
    } else {
      mBox.remove();
    }
    var sBox = root.querySelector('[data-mo-sws]');
    /* Reihenfolge: gewählte Farbe zuerst, Rest nach Beliebtheit. Kommt der Kunde per Farbwechsel aus der offenen Liste,
       bleibt die Reihenfolge der vorigen Seite stehen (sonst springen die Kreise unter dem Finger) */
    var prevOrd = [].map.call(sBox.querySelectorAll('a[href]'), function (a) { return a.getAttribute('href').replace(/\/$/, ''); });
    var list = Object.keys(map).filter(function (k) { return k.indexOf(me.m + '|') === 0; }).map(function (k) { return map[k]; })
      .sort(function (a, b) {
        if (prevOrd.length) {
          var ia = prevOrd.indexOf('/products/' + a.p.h), ib = prevOrd.indexOf('/products/' + b.p.h);
          if (ia < 0) ia = 999; if (ib < 0) ib = 999;
          if (ia !== ib) return ia - ib;
        } else {
          if (a.c === me.c) return -1;
          if (b.c === me.c) return 1;
        }
        return popOrder(a.c) - popOrder(b.c);
      });
    /* Ab 5 Farben zugeklappt: nur gewählte Farbe + Knopf „Weitere Farben ansehen“ */
    wahl.classList.toggle('mo-x', list.length > 4);
    var xn = root.querySelector('[data-mo-xn]');
    if (xn) xn.textContent = list.length - 1;
    sBox.innerHTML = list.map(function (f) {
      var on = f.c === me.c;
      return '<a class="mo-sw" href="/products/' + f.p.h + '" data-i="' + thumbU(f.p.i) + '" title="' + esc(cap(f.c)) + '" aria-label="' + esc(cap(f.c)) + '"' +
        (on ? ' aria-current="true"' : '') + ' style="background:' + swatchBg(f.c, f.p.i) + '"></a>';
    }).join('');
    root.querySelector('[data-mo-anz]').textContent = list.length + ' Farben';
    /* Seite der Farbe schon beim Berühren vorladen (schneller Wechsel) */
    function pf(e) {
      var a = e.target.closest && e.target.closest('a');
      if (a && !a.getAttribute('data-pf') && !a.getAttribute('aria-current')) {
        a.setAttribute('data-pf', '1');
        var l = document.createElement('link'); l.rel = 'prefetch'; l.href = a.href; document.head.appendChild(l);
        if (a.getAttribute('data-i')) (new Image()).src = a.getAttribute('data-i');
      }
    }
    /* Zurück-Taste (Seite aus dem Zwischenspeicher): ursprüngliche Farbe wieder markieren */
    var lblB = root.querySelector('.mo-lbl2 b'), lblTxt = lblB ? lblB.textContent : '';
    var curA = sBox.querySelector('a[aria-current]');
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      [].forEach.call(sBox.querySelectorAll('a[aria-current]'), function (x) { x.removeAttribute('aria-current'); });
      if (curA) curA.setAttribute('aria-current', 'true');
      if (lblB) lblB.textContent = lblTxt;
    });
    [sBox, mBox].forEach(function (box) {
      if (!box || !box.parentNode) return;
      box.addEventListener('pointerenter', pf, true);
      box.addEventListener('touchstart', pf, { passive: true, capture: true });
      /* Klick (Position merken, sofortige Markierung) übernimmt das Inline-Skript #mo-restore im Snippet */
    });
    wahl.classList.remove('is-loading');
    /* Farbbilder (240 px, je ~7 KB) vorladen, sobald die Farbwahl in Sicht kommt -> schneller Wechsel ohne Ladepause */
    var pre = function () {
      var us = [].map.call(root.querySelectorAll('[data-mo-wahl] [data-i]'), function (a) { return a.getAttribute('data-i'); });
      /* je 6 gleichzeitig laden */
      var n = 0;
      function next() {
        if (n >= us.length) return;
        var im = new Image(); im.onload = im.onerror = next; im.src = us[n++];
      }
      for (var k = 0; k < 6; k++) next();
    };
    /* erst nach dem fertigen Laden der Seite (Seite meldet „fertig“ nicht später als ohne Farbbilder) */
    function afterLoad(fn) {
      if (document.readyState === 'complete') setTimeout(fn, 300);
      else window.addEventListener('load', function () { setTimeout(fn, 300); });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); afterLoad(pre); } }, { rootMargin: '300px 0px' });
      io.observe(sBox);
    } else { afterLoad(pre); }
  }

  /* ---------- Sterne ---------- */
  function revStats(fam) {
    var cnt = 0, sum = 0;
    fam.forEach(function (f) {
      var c = +f.p.rc || 0, a = +f.p.ra || 0;
      cnt += c; sum += c * a;
    });
    return { cnt: cnt, avg: cnt ? Math.round(sum / cnt * 10) / 10 : 0 };
  }
  function fmtAvg(avg) { return avg.toFixed(1).replace('.', ','); }
  function starStr(avg) { var n = Math.round(avg); return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n); }
  function buildStars(fam) {
    var s = revStats(fam), a = root.querySelector('[data-mo-stars]');
    if (!s.cnt || !a) return;
    a.innerHTML = '<b>' + starStr(s.avg) + '</b> ' + fmtAvg(s.avg) + ' · <u>' + s.cnt +
      ' Bewertung' + (s.cnt === 1 ? '' : 'en') + '</u> <span>(alle Farben)</span>';
    a.hidden = false;
  }

  /* ---------- Lazy ---------- */
  function lazy(sel, fn) {
    var sec = el(sel);
    if (!sec) return;
    if (!('IntersectionObserver' in window)) { fn(sec); return; }
    var io = new IntersectionObserver(function (en) {
      if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); fn(sec); }
    }, { rootMargin: '700px 0px' });
    io.observe(sec.parentElement || sec);
  }

  /* ---------- Bewertungen ---------- */
  function buildReviews(sec, colHandle, fam) {
    var s = revStats(fam);
    if (!s.cnt) return;
    var handles = {};
    fam.forEach(function (f) { handles[f.p.h] = f; });
    getJSON('/collections/' + encodeURIComponent(colHandle) + '?view=mofamrev')
      .then(function (data) {
        var dist = [0, 0, 0, 0, 0], revs = [];
        (data.items || []).forEach(function (p) {
          var f = handles[p.h];
          if (!f || !p.d) return;
          var d; try { d = typeof p.d === 'string' ? JSON.parse(p.d) : p.d; } catch (e) { return; }
          var st = d.reviews_statistic || {};
          for (var i = 1; i <= 5; i++) dist[i - 1] += +st['total_rating_' + i] || 0;
          (d.reviews || []).forEach(function (r) {
            if (r.deleted_at || r.status === false) return;
            var txt = (r.content || '').trim();
            if (r.rating < 4 || txt.length < 8) return;  /* nur Bewertungen mit Text als Karte */
            revs.push({ t: txt, n: (r.reviewer_name || '').trim(), s: r.rating, d: r.created_at || '', v: !!r.is_verified, c: f.c, m: f.m });
          });
        });
        var total = dist.reduce(function (a, b) { return a + b; }, 0) || s.cnt;
        var avg = total ? Math.round(dist.reduce(function (a, b, i) { return a + b * (i + 1); }, 0) / total * 10) / 10 : s.avg;
        if (!dist.some(Boolean)) avg = s.avg;
        /* eigene Farbe + Metall zuerst, dann nach Datum */
        revs.sort(function (a, b) {
          var oa = (a.c === me.c && a.m === me.m) ? 0 : 1, ob = (b.c === me.c && b.m === me.m) ? 0 : 1;
          if (oa !== ob) return oa - ob;
          return a.d < b.d ? 1 : -1;
        });
        var own = handles[root.getAttribute('data-handle')];
        var ownC = own ? +own.p.rc || 0 : 0, ownA = own ? +own.p.ra || 0 : 0;
        var bars = [5, 4, 3, 2, 1].map(function (n) {
          var c = dist[n - 1], w = total ? Math.round(c / total * 100) : 0;
          return '<div>' + n + '★ <i><b style="width:' + w + '%"></b></i> ' + c + '</div>';
        }).join('');
        function dat(d) { var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(d || ''); return m ? m[3] + '.' + m[2] + '.' + m[1] : ''; }
        function card(r, hide) {
          return '<div class="mo-rc"' + (hide ? ' hidden' : '') + '><div class="mo-rh"><b>' + starStr(r.s) + '</b><span>' + dat(r.d) + '</span></div>' +
            (r.t ? '<p>„' + esc(r.t) + '“</p>' : '') +
            '<div class="mo-rn"><strong>' + (r.n ? esc(r.n) : 'Anonym') + '</strong>' + (r.v ? ' <em>✓ Verifizierter Kauf</em>' : '') + '</div>' +
            '<small>Gekauft: ' + MNAME[r.m] + ' · ' + esc(cap(r.c)) + '</small></div>';
        }
        var shown = revs.slice(0, 3).map(function (r) { return card(r, false); }).join('');
        var more = revs.slice(3, 10).map(function (r) { return card(r, true); }).join('');
        var ownLine = ownC ? ' <b>Diese Farbe in ' + MSHORT[me.m] + ': ' + fmtAvg(ownA) + ' aus ' + ownC + '.</b>' : '';
        sec.innerHTML = '<h3>Bewertungen zu diesem Motiv</h3><div class="mo-score"><div><div class="mo-big">' + fmtAvg(avg) +
          '</div><div class="mo-gold">' + starStr(avg) + '</div><div class="mo-note">' + total + ' Bewertung' + (total === 1 ? '' : 'en') +
          '</div></div><div class="mo-bars">' + bars + '</div></div>' +
          '<p class="mo-revnote">Alle Farben &amp; Metalle dieses Motivs zusammen.' + ownLine + '</p>' + shown + more +
          (more ? '<button type="button" class="mo-more">Weitere Bewertungen anzeigen</button>' : '');
        var btn = sec.querySelector('.mo-more');
        if (btn) btn.addEventListener('click', function () {
          sec.querySelectorAll('.mo-rc[hidden]').forEach(function (x) { x.hidden = false; }); btn.remove();
        });
        sec.hidden = false;
        hideTrustify();
      }).catch(function () {});
  }
  function hideTrustify() {
    var tries = 0;
    (function tick() {
      var box = document.querySelector('.product__section .trustify-review-box');
      if (box) {
        var blk = box.closest('.product__section-content__block') || box;
        blk.style.display = 'none';
      } else if (tries++ < 20) setTimeout(tick, 500);
    })();
  }

  /* ---------- Duo ---------- */
  /* Produktfotos sind unterschiedlich gerahmt (Armband mal höher, mal größer im Bild).
     Armband im Foto suchen (nicht-weiße Pixel) und einheitlich mittig + gleich breit zeigen,
     damit die drei Vorschläge optisch in einer Reihe stehen. */
  function fitPhoto(img) {
    var done = false;
    function show() { if (!done) { done = true; img.classList.add('is-ok'); } }
    function run() {
      try {
        var N = 96, cv = document.createElement('canvas'); cv.width = cv.height = N;
        var cx = cv.getContext('2d', { willReadFrequently: true });
        cx.drawImage(img, 0, 0, N, N);
        var d = cx.getImageData(0, 0, N, N).data, x0 = N, x1 = -1, y0 = N, y1 = -1;
        for (var y = 0; y < N; y++) for (var x = 0; x < N; x++) {
          var i = (y * N + x) * 4;
          if (Math.min(d[i], d[i + 1], d[i + 2]) < 232) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
        }
        if (x1 > x0 + 8 && y1 > y0 + 4) {
          var bw = (x1 - x0 + 1) / N, bh = (y1 - y0 + 1) / N, mx = (x0 + x1 + 1) / 2 / N, my = (y0 + y1 + 1) / 2 / N;
          /* gleich breit (90 %), Oberkante (Logo-Plättchen) immer auf gleicher Höhe -> Bänder und Plättchen in einer Linie */
          var s = Math.min(0.9 / bw, 0.8 / bh, 1.8), top = Math.max(0.1, Math.min(0.24, 0.5 - bh * s / 2));
          var ty = (top - 0.5) / s - (y0 / N - 0.5);
          img.style.transform = 'scale(' + s.toFixed(3) + ') translate(' + ((0.5 - mx) * 100).toFixed(2) + '%,' + (ty * 100).toFixed(2) + '%)';
        }
      } catch (e) { /* fremde Domain (Vorschau) o. Ä.: Foto unverändert zeigen */ }
      show();
    }
    setTimeout(show, 2500);
    if (img.complete && img.naturalWidth) run(); else { img.addEventListener('load', run); img.addEventListener('error', show); }
  }
  function buildDuo(sec, ownCol, ownMap) {
    var found = [], usedCol = {}, usedGrp = {}, myGrp = grp(me.key);
    usedGrp[myGrp] = 1;
    /* Farbliste: feste Partnerfarben, danach Beliebtheit als Ausweichliste; nie die eigene Farbe, nie Auslauffarben */
    var cols = (PAIR[me.c] || []).concat(POP).filter(function (c, i, a) {
      return c !== me.c && HIDE.indexOf(c) < 0 && a.indexOf(c) === i;
    });
    function ok(f, c) { return f && f.c === c && f.m === me.m && f.p && f.p.a && HIDE.indexOf(f.c) < 0; }
    /* Partner ohne eigene Motivgruppe (Gruppe aus dem Kollektionsnamen vorab, genau geprüft je Produkt) */
    var queue = PARTNER.filter(function (h) { return h !== ownCol && grp(h) !== myGrp; });
    var motifs = [];
    function fill() {
      /* Karte für Karte: nächste Partnerfarbe, beliebtestes noch freies Motiv (andere Gruppe), gleiches Metall, lieferbar */
      for (var k = 0; k < cols.length && found.length < 3; k++) {
        var c = cols[k];
        if (usedCol[c]) continue;
        for (var j = 0; j < motifs.length; j++) {
          var mm = motifs[j];
          if (usedGrp[mm.g] || !mm.byC[c]) continue;
          found.push(mm.byC[c]); usedCol[c] = 1; usedGrp[mm.g] = 1; break;
        }
      }
    }
    function step() {
      var batch = queue.splice(0, 5);
      if (!batch.length) { render(); return; }
      Promise.all(batch.map(function (h) { return loadCol(h).catch(function () { return {}; }); })).then(function (all) {
        all.forEach(function (d) {
          var byG = {};
          (d.items || []).forEach(function (p) {
            var f = parse(p.t, p.h);
            if (!f) return;
            var g = grp(f.key);
            if (g === myGrp) return;
            f.p = p;
            var e = byG[g] || (byG[g] = { g: g, byC: {} });
            if (ok(f, f.c) && !e.byC[f.c]) e.byC[f.c] = f;
          });
          Object.keys(byG).forEach(function (g) { motifs.push(byG[g]); });
        });
        /* neu verteilen: Reihenfolge der Motive = Beliebtheit (Reihenfolge in PARTNER) */
        found = []; usedCol = {}; usedGrp = {}; usedGrp[myGrp] = 1;
        fill();
        if (found.length < 3 && queue.length) step(); else render();
      });
    }
    function render() {
      if (!found.length) return;
      sec.innerHTML = '<h3>Passt dazu</h3><div class="mo-cards mo-g3">' +
        found.map(function (f) {
          return '<div class="mo-card"><a href="/products/' + f.p.h + '"><span class="mo-ph"><img alt="' + esc(f.name + ' ' + cap(f.c)) + '" src="' + f.p.i +
            '" width="130" height="130"></span><b>' + esc(f.name) + '</b></a><span>' + esc(cap(f.c)) + ' · ' + money(f.p.p) + '</span>' +
            '<button type="button" class="mo-add" data-v="' + f.p.v + '">+ Dazulegen</button></div>';
        }).join('') + '</div>';
      sec.hidden = false;
      [].forEach.call(sec.querySelectorAll('.mo-ph img'), fitPhoto);
      /* Dazulegen an/aus: 1. Tippen legt 1 Stück in den Warenkorb, 2. Tippen nimmt genau dieses Stück wieder heraus */
      var J = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      function setBtn(b, on) {
        b.classList.toggle('is-done', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.innerHTML = on ? '✓ Dazugelegt<i aria-hidden="true">✕</i>' : '+ Dazulegen';
        b.title = on ? 'Nochmal tippen zum Entfernen' : '';
      }
      function count(c) {
        document.querySelectorAll('.js-cart-count, .cart-count, [data-cart-count], .cart__count').forEach(function (n) { n.textContent = c.item_count; });
      }
      function getCart() { return fetch('/cart.js', { credentials: 'same-origin', headers: J }).then(function (r) { return r.json(); }); }
      /* Stand aus dem Warenkorb übernehmen (Neu laden / Zurück-Taste) */
      function sync() {
        getCart().then(function (c) {
          sec.querySelectorAll('.mo-add').forEach(function (b) {
            var v = +b.getAttribute('data-v');
            if (!b.disabled) setBtn(b, c.items.some(function (it) { return it.variant_id === v; }));
          });
        }).catch(function () {});
      }
      sec.querySelectorAll('.mo-add').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      sync();
      window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
      sec.addEventListener('click', function (e) {
        var b = e.target.closest('.mo-add');
        if (!b || b.disabled) return;
        var v = +b.getAttribute('data-v'), on = b.classList.contains('is-done');
        /* sofort umschalten (fühlt sich ohne Wartezeit an), bei Fehler zurück */
        b.disabled = true; b.classList.add('is-busy'); setBtn(b, !on);
        var job = on
          ? getCart().then(function (c) {
              var it = c.items.filter(function (x) { return x.variant_id === v; })[0];
              if (!it) return c;
              return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: J,
                body: JSON.stringify({ id: it.key, quantity: Math.max(it.quantity - 1, 0) }) })
                .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
            })
          : fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: J,
              body: JSON.stringify({ items: [{ id: v, quantity: 1 }] }) })
              .then(function (r) { if (!r.ok) throw new Error(r.status); return getCart(); });
        job.then(function (c) {
          b.disabled = false; b.classList.remove('is-busy');
          setBtn(b, !on); count(c);
        }).catch(function () {
          b.disabled = false; b.classList.remove('is-busy');
          if (on) setBtn(b, true); else { setBtn(b, false); b.textContent = 'Nicht verfügbar'; b.disabled = true; }
        });
      });
    }
    step();
  }

  /* ---------- Weitere Farben ---------- */
  function buildFarben(map) {
    var sec = el('[data-mo-farben]');
    if (!sec) return;
    var list = POP.filter(function (c) { return c !== me.c && map[me.m + '|' + c]; }).slice(0, 4)
      .map(function (c) { return map[me.m + '|' + c]; });
    if (list.length < 2) return;
    sec.innerHTML = '<h3>Beliebte Farben</h3><div class="mo-g2">' + list.map(function (f) {
      return '<a class="mo-card" href="/products/' + f.p.h + '"><img loading="lazy" alt="' + esc(me.name + ' ' + cap(f.c)) + '" src="' + f.p.i +
        '" width="300" height="300"><b>' + esc(cap(f.c)) + ', ' + MSHORT[f.m] + '</b>' + money(f.p.p) + '</a>';
    }).join('') + '</div>';
    sec.hidden = false;
  }
})();
